(function ($) {
    $(function () {
        // Modal Slider
        $('.js-modal-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: false,
            autoplay: false,
            prevArrow: $('.js-previous-slide'),
            nextArrow: $('.js-next-slide'),     
        });

        // Urnwall Slider
        $('.js-urn-slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            var countedSlide = slick.slideCount === 0 ? 1 : slick.slideCount
            $('.js-urnwall-slider-counter').text(i + '/' + countedSlide);
        });

        $('.js-urn-slider').slick({
            autoplay: false,
            infinite: false,
            variableWidth: false,
            prevArrow: $('.js-urnwall-left-arrow'),
            nextArrow: $('.js-urnwall-right-arrow'),      
            slidesToShow: 1
        })
    });
})(jQuery);